/* eslint-disable no-unused-vars */
export enum AnalyticsType {
  LINE = 'line',
  BAR = 'bar',
}
